var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "user-reset-password" }, [
    _c(
      "div",
      {
        staticClass:
          "card w-50 mx-auto p-5 d-flex align-items-center rounded shadow",
        attrs: { id: "main-card" }
      },
      [
        _c("div", { staticClass: "container h-100" }, [
          _c("div", { staticClass: "row justify-content-md-center" }, [
            _c("div", { staticClass: "col-12 mx-auto" }, [
              _vm.agencyLogo
                ? _c("img", {
                    attrs: {
                      id: "qrp-logo",
                      src: require("../../assets/clients/" +
                        _vm.agencyLogo +
                        ".svg"),
                      alt: "Rating Platform Logo",
                      width: "100%",
                      height: "auto"
                    }
                  })
                : _c("img", {
                    attrs: {
                      id: "qrp-logo",
                      src: require("../../assets/qrp-rtm-color.svg"),
                      alt: "QuinStreet Rating Platform",
                      width: "100%",
                      height: "auto"
                    }
                  })
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "mx-auto w-100",
            attrs: { id: "card-inner-container" }
          },
          [
            _c("div", { staticClass: "row justify-content-md-center" }, [
              _c("div", { staticClass: "col-12" }, [
                _vm._m(0),
                _vm._v(" "),
                _vm.viewUsage
                  ? _c(
                      "form",
                      { staticClass: "my-3" },
                      [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            {
                              staticClass: "col-12 col-lg-10 col-xl-7 mx-auto"
                            },
                            [
                              _c(
                                "h1",
                                { staticClass: "text-center text-primary" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.displayContent[_vm.viewUsage]
                                        .displayTitle
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "text-center smaller-font-content"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.displayContent[_vm.viewUsage]
                                        .displayDescription
                                    )
                                  )
                                ]
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _vm.viewUsage === "reset" ||
                        _vm.viewUsage === "expired" ||
                        _vm.viewUsage === "expiredReset"
                          ? _c("div", { staticClass: "form-row mx-0" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "form-group col-12 col-lg-10 col-xl-7 mb-0 px-2 mx-auto"
                                },
                                [
                                  _c("field-label", {
                                    attrs: {
                                      fieldData: _vm.fieldElement["userEmail"]
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("field-tooltip", {
                                    attrs: {
                                      fieldData: _vm.fieldElement["userEmail"]
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("input-text", {
                                    ref: _vm.userNameRef,
                                    attrs: {
                                      fieldData: _vm.fieldElement["userEmail"]
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("field-messages", {
                                    attrs: {
                                      fieldData: _vm.fieldElement["userEmail"]
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.viewUsage === "update"
                          ? _c("password-update", {
                              attrs: {
                                fieldElement: _vm.fieldElement,
                                passwordInputType: _vm.passwordInputType
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-md-12 form-group text-center text-notice"
                          },
                          [
                            _c("form-messages", {
                              attrs: { formMessages: _vm.formMessages }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "text-center" }, [
                          _vm.viewUsage === "reset" ||
                          _vm.viewUsage === "expired"
                            ? _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-primary mx-3 mb-2 mb-md-0",
                                  attrs: { type: "submit" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.requestPasswordToken($event)
                                    }
                                  }
                                },
                                [_vm._v("Reset Password")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.viewUsage === "expiredReset"
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary mx-3",
                                  attrs: { type: "submit" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.requestPasswordToken($event)
                                    }
                                  }
                                },
                                [_vm._v("Request Link")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.viewUsage === "update"
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary mx-3",
                                  attrs: { type: "submit" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.updatePassword($event)
                                    }
                                  }
                                },
                                [_vm._v("Reset Password")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.viewUsage === "reset"
                            ? _c(
                                "a",
                                {
                                  staticClass:
                                    "text-link qrp-text-muted small mx-3",
                                  attrs: { href: "" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.$router.push({ name: "login" })
                                    }
                                  }
                                },
                                [_vm._v("Cancel")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.viewUsage === "expiredReset"
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn btn-muted",
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.$router.push({ name: "login" })
                                    }
                                  }
                                },
                                [_vm._v("Login")]
                              )
                            : _vm._e()
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm._m(1)
              ])
            ]),
            _vm._v(" "),
            _c("main-footer", {
              attrs: { id: "main-footer", role: "contentinfo" }
            })
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12 col-lg-10 col-xl-7 mx-auto" }, [
        _c("hr", { attrs: { id: "login-card-hr" } })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12 col-lg-10 col-xl-7 mx-auto" }, [
        _c("hr", { attrs: { id: "login-card-hr-bottom" } })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-243e3de6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-243e3de6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/user/ResetPassword.vue
// module id = null
// module chunks = 